import httpClient from '../utils/httpClient';

const API = '/employee-contract';

export const createContract = async (data) => httpClient.post(API, data);
export const getAllContracts = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.employeeId) params.append('employeeId', filters.employeeId);
  const qs = params.toString();
  return httpClient.get(qs ? `${API}?${qs}` : API);
};
export const getContractsByEmployee = async (employeeId) => httpClient.get(`${API}/employee/${employeeId}`);
export const getExpiringContracts = async (days = 30) => httpClient.get(`${API}/expiring?days=${days}`);
export const getContract = async (id) => httpClient.get(`${API}/${id}`);
export const updateContract = async (id, data) => httpClient.put(`${API}/${id}`, data);
export const terminateContract = async (id, data = {}) =>
  httpClient.put(`${API}/${id}/terminate`, data);
export const renewContract = async (id, data) => httpClient.put(`${API}/${id}/renew`, data);
